import React, { useState } from "react";
import "./authPages.css";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import CustomButton from "../../components/CustomButton";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState(false);
  // const navigate = useNavigate();

  const isFormValid = email;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.get(
        `${base_url.api1}/users/forgot_password?email=${email}`
      );
      console.log(response);
      setEmailSent(true);
    } catch (error) {
      console.log(error);
      setError(error.response?.data?.message);
      toast.error(error.response?.data?.message);
    }
  };

  const handleAnotherLink = async (e) => {
    try {
      const response = await axios.get(
        `${base_url.api1}/users/forgot_password?email=${email}`
      );
      console.log(response);
      setEmailSent(true);
    } catch (error) {
      //   console.log(error);
      toast.error(error.response?.data?.message);
      setError(error.response?.data?.message);
      setEmailSent(false);
    }
  };
  return (
    <div>
      <Nav />
      <div className="login forget-wrapper">
        <ToastContainer />
        {!emailSent ? (
          <div className="login-container">
            <div>
              <h3 className="login-header">Forgot password</h3>
              <p className="sub-login-header">
                Enter the email linked to your account, and we'll send you
                instructions to reset your password.
              </p>
            </div>

            <form className="input-container" onSubmit={(e) => handleSubmit(e)}>
              <div style={{ marginTop: "20px" }}>
                <label className="login-label">
                  Email address <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder={"Enter your email"}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div style={{ marginTop: "5px" }}>
                {error ? (
                  <p style={{ textAlign: "center", color: "#D04244" }}>
                    {error}
                  </p>
                ) : (
                  <p></p>
                )}
              </div>

              <CustomButton
                style={{
                  width: "100%",
                  marginTop: "25px",
                  backgroundColor: !isFormValid ? "#ccc" : "#314064",
                  cursor: !isFormValid ? "not-allowed" : "pointer",
                }}
                btnText="SEND THE LINK"
                type="submit"
                disabled={!isFormValid}
              />
            </form>
          </div>
        ) : (
          <div className="login-container">
            <div style={{ marginTop: "20px" }}>
              <h3>Check your inbox</h3>
              <p style={{ marginTop: "20px" }}>
                {`We’ve sent you an email with instructions on how to reset your
                password to ${email}.`}
              </p>
              <p>
                If you haven't received the reset email, don't worry. We'll send
                you another link shortly.
              </p>
            </div>

            <CustomButton
              style={{ width: "100%", marginTop: "25px" }}
              btnText="SEND ANOTHER LINK"
              onClick={(e) => handleAnotherLink(e)}
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
